import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent {
  private _currentPage: number = 1;
  private _totalPages: number = 50;

  @Output() pageChanged = new EventEmitter<number>();

  pages: Array<number | string> = [];
  loading: boolean = false;

  @Input()
  set currentPage(value: number) {
    this._currentPage = value;
    this.generatePagination();
  }

  get currentPage(): number {
    return this._currentPage;
  }

  @Input()
  set totalPages(value: number) {
    this._totalPages = value;
    this.generatePagination();
  }

  get totalPages(): number {
    return this._totalPages;
  }

  private generatePagination(): void {
    event?.preventDefault();
    this.pages = [];

    // Define the number of pages to display in the pagination bar
    const maxPages = 5;
    const totalNumbers = maxPages + 4; // 5 pages + 2 ellipses + 2 end pages
    const startPage = Math.max(2, this.currentPage - Math.floor(maxPages / 2));
    const endPage = Math.min(this.totalPages - 1, startPage + maxPages - 1);

    if (totalNumbers >= this.totalPages) {
      for (let i = 1; i <= this.totalPages; i++) {
        this.pages.push(i);
      }
    } else {
      this.pages = [1];

      const hasLeftEllipsis = startPage > 2;
      const hasRightEllipsis = (this.totalPages - endPage) > 1;

      if (hasLeftEllipsis) {
        this.pages.push('...');
      }

      for (let i = startPage; i <= endPage; i++) {
        this.pages.push(i);
      }

      if (hasRightEllipsis) {
        this.pages.push('...');
      }

      this.pages.push(this.totalPages);
    }
  }

  onPageChange(page: number | string): void {
    event?.preventDefault();
    if (page === '...') return;
    const pageNumber = Number(page);
    if (pageNumber !== this.currentPage) {
      this.pageChanged.emit(pageNumber);
    }
  }
}
